import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import { passagesArr } from './constants/PassagesText';
import './Passages.css';

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
  }
}

class Passages extends Component {
  render() {
    const randomPassage = passagesArr[Math.floor(Math.random() * passagesArr.length)];
    const {
      headline,
      author,
      body,
    } = randomPassage;

    const {
      fonts,
    } = this.props;

    const {
      primary,
      secondary
    } = fonts;

    return (
      <div className="passages-wrapper">
        <Paper
          zDepth={1}
          className="passages-paper">
          <div className="passage-header"
            style={{
              fontFamily: primary.name,
              fontSize: '2.5em',
              fontWeight: 600
            }}>
            {headline}
          </div>
          <div className="passage-author"
            style={{
              fontFamily: secondary.name,
              fontSize: '1.5em',
              fontWeight: 600
            }}>
            By {author}
          </div>
          <div className="passage-body"
            style={{
              fontFamily: secondary.name,
              fontSize: '1em',
              lineHeight: '1.5em',
              color: '#333'
            }}>
            {body}
          </div>
        </Paper>
        <Paper
          zDepth={1}
          className="passages-paper">
          <div className="passage-header"
            style={{
              fontFamily: primary.name,
              fontSize: '3em',
              fontWeight: 600
            }}>
            {headline}
          </div>
          <div className="passage-author"
            style={{
              fontFamily: secondary.name,
              fontSize: '1.8em',
              lineHeight: '2em',
              fontWeight: 600
            }}>
            By {author}
          </div>
          <div className="passage-body"
            style={{
              fontFamily: secondary.name,
              fontSize: '1.2em',
              lineHeight: '1.8em',
              color: '#333'
            }}>
            {body}
          </div>
        </Paper>
        <div className="clear"></div>
        <Paper
          zDepth={1}
          className="passages-paper">
          <div className="passage-header"
            style={{
              fontFamily: primary.name,
              fontSize: '3em',
              fontStyle: 'italic',
              fontWeight: 600
            }}>
            {headline}
          </div>
          <div className="passage-author"
            style={{
              fontFamily: secondary.name,
              fontSize: '1em',
              lineHeight: '2em',
              fontWeight: 600
            }}>
            By {author}
          </div>
          <div className="passage-body"
            style={{
              fontFamily: secondary.name,
              fontSize: '1em',
              lineHeight: '2.5em',
              color: '#333'
            }}>
            {body}
          </div>
        </Paper>
        <Paper
          zDepth={1}
          className="passages-paper">
          <div className="passage-header"
            style={{
              fontFamily: primary.name,
              fontSize: '2em',
              fontStyle: 'bold',
              fontWeight: 300
            }}>
            {headline}
          </div>
          <div className="passage-author"
            style={{
              fontFamily: secondary.name,
              fontSize: '1em',
              lineHeight: '2em',
              fontWeight: 300
            }}>
            {author}
          </div>
          <div className="passage-body"
            style={{
              fontFamily: secondary.name,
              fontSize: '1em',
              fontWeight: 300,
              lineHeight: '2em',
              color: '#333'
            }}>
            {body}
          </div>
        </Paper>
      </div>
    )
  }
}

export default Passages = connect(mapStateToProps, undefined)(Passages);



// WEBPACK FOOTER //
// ./src/components/generator/Passages.jsx